import {
  Directive,
  Host,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { DropdownComponent } from '@appkit4/angular-components/dropdown';
import { Subscription } from 'rxjs';
import { APPKIT_DROPDOWN_NO_RESULT_MSG } from '../utils/appkit-dropdown.util';

/**
 * AppKit ap-dropdown defaults noResultMsg to "" which suppresses the built-in
 * empty-state row. This directive restores "No data found" for empty lists and
 * when search/filter returns no matches.
 */
@Directive({
  selector: 'ap-dropdown',
  standalone: false,
})
export class AppkitDropdownEmptyStateDirective implements OnInit, OnDestroy {
  private readonly subs = new Subscription();

  constructor(@Host() private readonly dropdown: DropdownComponent) {}

  ngOnInit(): void {
    this.applyNoResultMessage();
    this.refreshBlankPageForEmptyList();

    this.subs.add(
      this.dropdown.onVisibleChange.subscribe((event: { dropdownStatus?: boolean }) => {
        if (event?.dropdownStatus) {
          this.applyNoResultMessage();
          this.refreshBlankPageForEmptyList();
        }
      })
    );

    this.subs.add(
      this.dropdown.onFilterResult.subscribe(() => {
        this.applyNoResultMessage();
        if (!String(this.dropdown.searchText || '').trim()) {
          this.refreshBlankPageForEmptyList();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyNoResultMessage(): void {
    if (this.dropdown.noResultMsg === '' || this.dropdown.noResultMsg == null) {
      this.dropdown.noResultMsg = APPKIT_DROPDOWN_NO_RESULT_MSG;
    }
  }

  private refreshBlankPageForEmptyList(): void {
    const list = Array.isArray(this.dropdown.list) ? this.dropdown.list : [];
    const searching = !!(
      this.dropdown.showSearchbox && String(this.dropdown.searchText || '').trim()
    );

    if (!searching && list.length === 0) {
      this.dropdown.showBlankPage = true;
    } else if (!searching) {
      this.dropdown.showBlankPage = false;
    }
  }
}
